<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>
<script>
  import { qqMap } from '/utils/qqMap.js'
  import { setStore } from '/utils/storage'
  export default {
    name: 'app',
    methods: {
      setCenter (position) {
        setStore('center_lat', position.lat)
        setStore('center_lng', position.lng)
        let location = position.nation + ',' + position.province + ',' + position.city
        if (position.addr !== '') {
          location = location + ',' + position.addr
        }
        setStore('location', location)
      },
      setInitCenter () {
        setStore('center_lat', 38.91943)
        setStore('center_lng', 121.630539)
        setStore('location', '中国,辽宁省,大连市')
      }
    },
    created () {
      qqMap().then(qq => {
        var geolocation = new qq.maps.Geolocation('AU4BZ-EYOCW-GSPRP-OKPW6-GCJD3-FXFXM', 'zxmall')
        setTimeout(() => { geolocation.getLocation(this.setCenter, this.setInitCenter()) }, 800)
      })
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background: #e9e5f3;;
  }
</style>



// WEBPACK FOOTER //
// App.vue?fdd9411c